// Charge la base commune
import './common.js'

// Alert modal
async function getAlertModal () {
  import(/* webpackChunkName: "alertModal" */ './js/components/alertModal.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// Home hero
function getHomeHero () {
  import(/* webpackChunkName: "homeHero" */ './js/components/homeHero.js').then(() => {
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  if ($('#alert-modal').length) { getAlertModal() }

  // gestion des carousel
  $('#homeHero').waypoint(function () {
    getHomeHero()
    this.destroy()
  }, {
    offset: '100%'
  })
})
